export enum WorkflowGroupingKey {
  CATEGORY = 'category',
  TYPE = 'type',
  STATUS = 'status',
  DATE = 'date',
  TIME = 'time',
  COMPANY = 'company',
  CONTACT = 'contact',
  LOCATION = 'location',
  EQUIPMENT = 'equipment',
  MATERIAL = 'material',
  FILE_TYPE = 'fileType',
  PROJECT = 'project',
}

export enum WorkflowSortingKey {
  NAME = 'name',
  CATEGORY = 'category',
  TYPE = 'type',
  STATUS = 'status',
  DATE = 'date',
  COMPANY = 'company',
  CONTACT = 'contact',
  LOCATION = 'location',
  EQUIPMENT = 'equipment',
  MATERIAL = 'material',
  FILE_TYPE = 'fileType',
  PROJECT = 'project',
}
